export class UserManagementRequest {

    constructor(public userName: string,
        public firstName: string,
        public lastName: string,
        public emailId: string,
        public phoneNumber: string) {
        
    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/userManagement/user-management-request.ts
 **/